import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TUserClientContact, TUserClientContactPayloadParams, TUserClientContactResponse, adaptUserClientContactFromResponse } from '../../types';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientContactReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_USER_CLIENT}/:client_id/contacts/:id`,
	(payload: TUserClientContactPayloadParams, thunkApi) => {
		const { id, clientId } = payload;
		const path = `${BACKEND_USER_CLIENT}/${clientId}/contacts/${id}`;

		return HttpService.get<TUserClientContactResponse>(path).then(result => {
			return adaptUserClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TUserClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientContactReadSlice = createSlice({
	name: 'userClientContactReadSlice',
	initialState,
	reducers: {
		setUserClientContactRead(state, action: PayloadAction<TUserClientContact>) {
			state.item = action.payload;
		},

		clearUserClientContactRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientContactReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientContactReadGetApi.fulfilled.type]: (state, action: PayloadAction<TUserClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientContactReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientContactReadSelector = () => useAppSelector(state => state[userClientContactReadSlice.name]);

export const { clearUserClientContactRead, setUserClientContactRead } = userClientContactReadSlice.actions;
